<template>

    <div class="container">

        <app-head title="Queue" />

        <h1 class="page-heading">
            {{ __('Queue') }}
        </h1>

        <div class="d-flex justify-content-between mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="supplier" v-model="form.supplier_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name }}</option>
                </select-input>
                <select-input label="importable_type" v-model="form.importable_type">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="k" v-for="(v, k) in importableTypeOptions">{{ v }}</option>
                </select-input>
                <text-input type="date" label="from" v-model="form.from" />
                <text-input type="date" label="until" v-model="form.until" />
            </search-filter>
        </div>

        <div class="card">
            <data-table :items="imports.data"
                        :links="imports.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="importItem in imports.data" :key="importItem.id">
                    <td>
                        {{ importItem.account.short_name || importItem.account.name }}
                    </td>
                    <td>
                        {{ importItem.importable_type }}
                    </td>
                    <td>
                        <div class="">
                            {{ importItem.file_basename }}
                        </div>
                        <div class="small text-muted">
                            {{ importItem.process_token }}
                        </div>
                    </td>
                    <td>
                        <span class="badge bg-dark" v-if="importItem.cancel_at">
                            {{ __('Abgebrochen') }}
                        </span>
                        <span class="badge bg-success" v-else-if="importItem.start_at && importItem.end_at">
                            {{ __('Abgeschlossen') }}
                        </span>
                        <span class="badge bg-info" v-if="importItem.start_at && importItem.end_at === null">
                            {{ __('In Bearbeitung') }}
                        </span>
                        <!--                    @todo    <span class="badge bg-info" v-if="importItem.start_at && importItem.end_at === null">
                                                    {{ __('Fehler') }}
                                                </span>-->
                    </td>
                    <td>
                        <div v-if="importItem.start_at">
                            {{ importItem.start_at | localizeDateTime }}
                        </div>
                        <div v-if="importItem.end_at">
                            {{ importItem.end_at | localizeDateTime }}
                        </div>
                    </td>
                    <td>
                        <div>
                            {{ importItem.number_importing || 0 | localizeNumber }}
                        </div>
                    </td>
                    <td>
                        <div class="progress" v-if="importItem.progress">
                            <div class="progress-bar" 
                                 role="progressbar" 
                                 :style="'width:' + importItem.progress + '%;'" 
                                 :aria-valuenow="importItem.progress" 
                                 aria-valuemin="0" 
                                 aria-valuemax="100">{{ importItem.progress + '%' }}</div>
                        </div>
                    </td>
                    <td>
                        {{ importItem.number_imported || 0 | localizeNumber }}
                    </td>
                    <td class="text-end">
<!--                     @todo   <inertia-link :href="route('admin.products.update-import-status', {import: importItem, action: 'cancel'})" 
                                      class="btn btn-outline-danger" 
                                      as="button"
                                      type="button"
                                      v-if="importItem.start_at && importItem.end_at === null">
                            {{ __('Abbrechen') }}
                        </inertia-link>-->
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';

    export default {
        props: [
            'filters',
            'importableTypeOptions',
            'imports',
            'suppliers',
        ],
        components: {
            TextInput,
            SelectInput,
            DataTable,
            DataTableRow,
            SearchFilter,
        },
        created() {
            // Refresh page data for progress bar
            this.interval = setInterval(function () {
                this.reloadPage();
            }.bind(this), 1500);
        },
        beforeDestroy() {
            clearInterval(this.interval); // this is important!
        },
        data() {
            return {
                interval: null,
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    supplier_id: this.filters.supplier_id,
                    from: this.filters.from,
                    until: this.filters.until,
                    importable_type: this.filters.importable_type,
                },
                columns: {
                    account: {label: 'Account'},
                    importable_type: {label: 'Type'},
                    process_token: {label: 'File, Process token'},
                    status: {label: 'Status'},
                    start_at: {label: 'Beginn/Ende'},
                    number_importing: {label: 'Items'},
                    progress: {label: 'Progress'},
                    number_imported: {label: 'Importiert'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.products.queue'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
            reloadPage() {
                this.$inertia.reload({/*preserveState: true, */preserveScroll: true/*, only: ['imports']*/});
            }
        },
        computed: {

        }
    }
</script>
